<div class="actiuni-card-container action-card-{{actionType}}" [class.selected]="selectedClass()">
    <div class="card-status">
        <div class="card-header">
            <span class="title">{{ title }}</span>
            <span class="description" *ngIf="
				(actionType == 'validate' && cerere?.validated_date == null) 
				|| (['invalidate', 'anulare'].includes(actionType) && cerere?.cancel_date == null)
				|| (actionType == 'finalizare')
			">{{ description }}</span>
        </div>
    </div>
    <div class="card-content" *ngIf="actionType == 'validate'">
        <div class="card-content__header">
            <span class="user"><i class="fa-regular fa-user"></i> {{ cerere?.validated_user_name }}</span>
            <span class="date"><i class="fa-regular fa-calendar-check"></i> {{ cerere?.validated_date }}</span>
        </div>
    </div>
    <div class="card-content" *ngIf="['invalidate', 'anulare'].includes(actionType) && cerere?.cancel_date !== null">
        <div class="card-content__header">
            <span class="user"><i class="fa-regular fa-user"></i> {{ cerere?.cancel_user_name }}</span>
            <span class="date"><i class="fa-regular fa-calendar-check"></i> {{ cerere?.cancel_date }}</span>
        </div>
        <div class="card-content__body">
            <div class="card-content__body__text">
                <i class="fa-regular fa-message"></i> {{ cerere?.cancel_obs }}
            </div>
        </div>
    </div>
    <div class="card-content"
        *ngIf="['finalizare'].includes(actionType) && cerere?.registratura?.finalize_date !== null">
        <div class="card-content__header">
            <span class="user"><i class="fa-regular fa-user"></i> {{ cerere?.registratura?.user_name }}</span>
            <span class="date"><i class="fa-regular fa-calendar-check"></i> {{ cerere?.registratura?.finalize_date
                }}</span>
            <span class="date"><i class="fa-regular fa-comments"></i> {{ cerere?.registratura?.finalize_name }}</span>
        </div>
        <div class="card-content__body">
            <div class="card-content__body__text">
                <i class="fa-regular fa-message"></i> {{ cerere?.registratura?.finalize_obs }}
            </div>
        </div>
    </div>
    <div class="card-actions">
        <div class="card-image">
            <mat-icon [ngStyle]="{'color': iconColor}">{{ iconName }}</mat-icon>
        </div>
        <div class="card-button">
            <button *ngIf="
                    (actionType == 'validate' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.validare-cerere')) 
                    || (actionType == 'invalidate' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.invalidare-cerere'))
                    || (actionType == 'anulare' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.clasare-cerere'))
                    || (actionType == 'finalizare' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.inchidere-lucrare'))
                " type="button" mat-raised-button color={{btnColor}} class="action-button" [disabled]="
					(actionType == 'validate' && cerere?.validated_date !== null) 
					|| (actionType == 'invalidate' && cerere?.cancel_date !== null)
					|| (actionType == 'anulare' && cerere?.cancel_date !== null)
                    || (actionType == 'finalizare' && cerere?.registratura?.finalize_date !== null)
				" (click)="onButtonClick()">{{ actionText }}</button>
        </div>
    </div>
    <div class="card-footer" *ngIf="
		(actionType == 'validate' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.resetare-validare') && cerere?.validated_date !== null && cerere?.cancel_type == null && cerere?.registratura?.finalize_date == null)
		|| (actionType == 'invalidate' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.resetare-invalidare') && cerere?.cancel_date !== null && cerere?.registratura?.finalize_date == null)
		|| (actionType == 'anulare' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.resetare-clasare') && cerere?.cancel_date !== null && cerere?.registratura?.finalize_date == null)
		|| (actionType == 'finalizare' && permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.resetare-finalizare') && cerere?.registratura?.finalize_date !== null)
	">
        <div class="card-button">
            <button type="button" mat-raised-button color={{btnColor}} class="action-button w-100"
                (click)="onButtonResetClick()"><mat-icon class="resetIcon"
                    style="color: 'red'">report_problem</mat-icon> Reset</button>
        </div>
    </div>
</div>